define(['jquery', 'jquery.transit', 'modernizr', 'container', 'router', 'jump', 'slider-carousel-infinite-enhanced', 'preloader', 'lightbox'],
    function ($, transit, modernizr, container, router, jumpFactory, sliderCarouselInfiniteEnhancedFactory, preloader, lightboxFactory) {

        return (function () {

            const name = 'about';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const jump = jumpFactory.create();
            const slider = sliderCarouselInfiniteEnhancedFactory.create();
            const lightbox = lightboxFactory.create();
            //const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {
            };

            view.privateVars = {
                currentItem: {
                    id: null,
                    cls: null
                },
                changeItemAnim: 0,
                characterGalleryAnim: 0,

                videoSize: {
                    width: 900,
                    height: 506
                },
            };

            view.startup = function () {
                view.privateVars.currentItem = view.publicVars.currentItem;

                $(view.publicVars.cssId.moduleAboutCharacterBoxCls).removeAttr('href');

                preloader.setPreloadBulk(view.publicVars.currentItem.cls, view.publicVars.preloadTab[view.publicVars.currentItem.cls]);

                lightbox.setCloseCallback(function () {
                    $(view.publicVars.cssId.moduleAboutVideoElementId).attr('src', '');
                    $(view.publicVars.cssId.moduleAboutVideoElementId).removeAttr('src');
                    $(view.publicVars.cssId.moduleAboutVideoElementId).attr('poster', '');
                    $(view.publicVars.cssId.moduleAboutVideoElementId).removeAttr('poster');
                });
            };

            view.bind = function () {
                $(view.publicVars.cssId.moduleAboutCharacterBoxCls).click(function () {
                    const id = container.getData($(this)[0], 'id');
                    if(id != view.privateVars.currentItem.id && view.privateVars.changeItemAnim == 0) {
                        view.privateVars.changeItemAnim = 1;
                        view.methods.changeBookSlide(id, this);
                    }
                });

                $(view.publicVars.cssId.moduleAboutBookSlideFrameVideoCls).click(function () {
                    view.methods.showLightbox(this);
                });

                $(view.publicVars.cssId.moduleAboutBookSlideGalleryControlsCircleCls).click(function () {
                    const id = container.getData($(this)[0], 'id');

                    if(!$(this).hasClass(view.publicVars.cssId.isActiveCls.substr(1)) && view.privateVars.characterGalleryAnim == 0) {
                        view.privateVars.characterGalleryAnim = 1;
                        view.methods.changeCharacterGallery(id, this);
                    }
                });

                $(window).resize(() => {
                    if (lightbox.getStatus() === 1) {
                        view.methods.calculateLightboxSize(view.privateVars.videoSize.width, view.privateVars.videoSize.height);
                    }
                });

                $(window).on('orientationchange', () => {
                    if (lightbox.getStatus() === 1) {
                        view.methods.calculateLightboxSize(view.privateVars.videoSize.width, view.privateVars.videoSize.height);
                    }
                });
            };

            view.methods = {

                isDesktop: () => {
                    if($('body').hasClass(view.publicVars.cssId.bodyDesktopCls.substr(1)) && $(window).outerWidth() > 1024) {
                        return true;
                    } else {
                        return false;
                    }
                },

                changeCharacterGallery: (id, handler) => {

                    let oldId = null;

                    $(view.publicVars.cssId.moduleAboutBookSlideGalleryControlsCircleCls,
                        view.publicVars.cssId.moduleAboutBookSlideId + view.privateVars.currentItem.id).each(function () {
                        if($(this).hasClass(view.publicVars.cssId.isActiveCls.substr(1))) {
                            oldId = container.getData($(this)[0], 'id');
                        }
                    });

                    $(view.publicVars.cssId.moduleAboutBookSlideGalleryControlsCircleCls,
                        view.publicVars.cssId.moduleAboutBookSlideId + view.privateVars.currentItem.id).removeClass(view.publicVars.cssId.isActiveCls.substr(1));

                    $(handler).addClass(view.publicVars.cssId.isActiveCls.substr(1));

                    $(view.publicVars.cssId.moduleAboutBookSlideGalleryCharacterCls + oldId,
                        view.publicVars.cssId.moduleAboutBookSlideId + view.privateVars.currentItem.id).transit({ opacity: 0, scale: 0.5}, function () {
                        $(view.publicVars.cssId.moduleAboutBookSlideGalleryCharacterCls + oldId,
                            view.publicVars.cssId.moduleAboutBookSlideId + view.privateVars.currentItem.id).css({ display: 'none', opacity: 1, scale: 1});

                        $(view.publicVars.cssId.moduleAboutBookSlideGalleryCharacterCls + id,
                            view.publicVars.cssId.moduleAboutBookSlideId + view.privateVars.currentItem.id).css({ display: 'block', opacity: 0, scale: 0.5});

                        $(view.publicVars.cssId.moduleAboutBookSlideGalleryCharacterCls + id,
                            view.publicVars.cssId.moduleAboutBookSlideId + view.privateVars.currentItem.id).transit({ opacity: 1, scale: 1}, function () {
                            view.privateVars.characterGalleryAnim = 0;
                        });
                    });
                },

                changeBookSlide: (id, handler) => {
                    const cls = container.getData($(handler)[0], 'cls');
                    const url = container.getData($(handler)[0], 'href.top');
                    const metaTitle = container.getData($(handler)[0], 'meta.title');
                    const oldId = view.privateVars.currentItem.id;
                    const oldCls = view.privateVars.currentItem.cls;

                    view.privateVars.currentItem.id = id;
                    view.privateVars.currentItem.cls = cls;

                    $(view.publicVars.cssId.moduleAboutCharacterBoxCls).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                    $(handler).addClass(view.publicVars.cssId.isActiveCls.substr(1));

                    router.route(url, metaTitle);

                    preloader.setPreloadBulk(cls, view.publicVars.preloadTab[cls]);

                    if(view.methods.isDesktop()) {
                        $(view.publicVars.cssId.moduleAboutBookSlideId + oldId).animateCss('animate__bounceOut', function () {

                            $(view.publicVars.cssId.moduleAboutBookSlideId + oldId).removeClass('animate__bounceOut');
                            $(view.publicVars.cssId.moduleAboutBookSlideId + oldId).css({display: 'none'});

                            view.methods.changeBookSlideOutCallback(oldId, oldCls);
                        });
                    } else {
                        const windowWidth = $(window).outerWidth();
                        let opacityValue = 0;

                        if(windowWidth < 768) {
                            opacityValue = 0.2;
                        }

                        $(view.publicVars.cssId.moduleAboutBookSlideId + oldId).transit({ opacity: opacityValue}, function () {
                            if($(window).outerWidth() > 767) {
                                $(view.publicVars.cssId.moduleAboutBookSlideId + oldId).css({
                                    display: 'none',
                                    opacity: 1
                                });
                            }

                            view.methods.changeBookSlideOutCallback(oldId, oldCls);
                        });
                    }

                },

                changeBookSlideOutCallback: (oldId, oldCls) => {
                    $(view.publicVars.cssId.moduleAboutBookWrapperLoaderId).removeClass(oldCls);
                    $(view.publicVars.cssId.moduleAboutBookWrapperLoaderId).addClass(view.privateVars.currentItem.cls);

                    $(view.publicVars.cssId.moduleAboutBookWrapperLoaderWrapperId).css({ display: 'block', opacity: 0, });

                    const windowWidth = $(window).outerWidth();

                    // if(windowWidth < 768) {
                        jump.centerTo(view.publicVars.cssId.moduleAboutBookWrapperLoaderWrapperId, {});
                    // }

                    $(view.publicVars.cssId.moduleAboutBookWrapperLoaderWrapperId).transit({ opacity: 1 }, 500, function () {
                        setTimeout(function () {
                            $(view.publicVars.cssId.moduleAboutBookWrapperLoaderWrapperId).transit({ opacity: 0 }, 500, function () {
                                preloader.getPreloadBulkFinished(view.privateVars.currentItem.cls, function () {
                                    if(view.methods.isDesktop()) {
                                        $(view.publicVars.cssId.moduleAboutBookSlideId + view.privateVars.currentItem.id).css({display: 'block'});
                                        $(view.publicVars.cssId.moduleAboutBookSlideId + view.privateVars.currentItem.id).animateCss('animate__bounceIn', function () {
                                            $(view.publicVars.cssId.moduleAboutBookSlideId + view.privateVars.currentItem.id).removeClass('animate__bounceIn');
                                            view.methods.changeBookSlideInCallback();
                                        });
                                    } else {
                                        if(windowWidth < 768) {
                                            $(view.publicVars.cssId.moduleAboutBookSlideId + oldId).css({
                                                display: 'none',
                                                opacity: 1
                                            });
                                        }

                                        $(view.publicVars.cssId.moduleAboutBookSlideId + view.privateVars.currentItem.id).css({display: 'block', opacity: 0});

                                        $(view.publicVars.cssId.moduleAboutBookSlideId + view.privateVars.currentItem.id).transit({ opacity: 1 }, function () {
                                            view.methods.changeBookSlideInCallback();
                                        });
                                    }
                                });
                            });
                        }, 1000);
                    });
                },

                changeBookSlideInCallback: () => {
                    view.privateVars.changeItemAnim = 0;
                },

                showLightbox: (handler) => {
                    const videoSrc = container.getData($(handler)[0], 'video.src');
                    const videoPoster = container.getData($(handler)[0], 'video.poster');

                    const lightboxSize = view.methods.calculateLightboxSize(view.privateVars.videoSize.width, view.privateVars.videoSize.height);

                    $(view.publicVars.cssId.moduleAboutVideoElementId).attr('poster', videoPoster);

                    $(view.publicVars.cssId.moduleAboutVideoElementId).css({ opacity: 0, scale: 0.5});
                    $(view.publicVars.cssId.moduleAboutVideoLightboxLoaderwrapperId).css({ display: 'block', opacity: 0, scale: 0, rotate: '0deg'})

                    lightbox.showLayer(function () {
                        $(view.publicVars.cssId.moduleAboutVideoLightboxLoaderwrapperId).transit({ opacity: 1, scale: 1, rotate: '360deg'}, 300, function () {

                            setTimeout(function () {
                                $(view.publicVars.cssId.moduleAboutVideoElementId).attr('src', videoSrc);
                                $(view.publicVars.cssId.moduleAboutVideoElementId)[0].play();
                                $(view.publicVars.cssId.moduleAboutVideoElementId).transit({ opacity: 1, scale: 1}, 300);
                            }, 500);

                        })
                    });
                },

                decorateSliderElement: (elem) => {
                    const id = parseInt(container.getData(elem[0], 'id'));

                    if (id === parseInt(view.privateVars.currentItem.id)) {
                        $(view.publicVars.cssId.moduleAboutCharacterBoxCls, elem).addClass(view.publicVars.cssId.isActiveCls.substr(1));
                    } else {
                        $(view.publicVars.cssId.moduleAboutCharacterBoxCls, elem).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                    }

                    return elem;
                },

                beforeSlideCallback: (handler) => {
                    handler.removeClass('animate__bounceIn');
                    handler.addClass('animate__zoomOut');
                },


                calculateLightboxSize: (width, height) => {

                    const windowWidth = $(window).width();
                    const windowHeight = $(window).height();

                    const paddingTop = parseInt($(view.publicVars.cssId.moduleAboutVideoLightboxAreaId).css('padding-top'));
                    const paddingBottom = parseInt($(view.publicVars.cssId.moduleAboutVideoLightboxAreaId).css('padding-bottom'));
                    const paddingLeft = parseInt($(view.publicVars.cssId.moduleAboutVideoLightboxAreaId).css('padding-left'));
                    const paddingRight = parseInt($(view.publicVars.cssId.moduleAboutVideoLightboxAreaId).css('padding-right'));

                    const paddingTopInner = parseInt($(view.publicVars.cssId.moduleAboutVideoLightboxInnerId).css('padding-top'));
                    const paddingBottomInner = parseInt($(view.publicVars.cssId.moduleAboutVideoLightboxInnerId).css('padding-bottom'));
                    const paddingLeftInner = parseInt($(view.publicVars.cssId.moduleAboutVideoLightboxInnerId).css('padding-left'));
                    const paddingRightInner = parseInt($(view.publicVars.cssId.moduleAboutVideoLightboxInnerId).css('padding-right'));

                    const topModifier = (- parseInt($(view.publicVars.cssId.moduleAboutVideoLightboxCloseId).css('top'))) * 2;
                    const rightModifier = (- parseInt($(view.publicVars.cssId.moduleAboutVideoLightboxCloseId).css('right'))) * 2;

                    const maxWidth = windowWidth - paddingLeft - paddingRight - paddingLeftInner - paddingRightInner - rightModifier;
                    const maxHeight = windowHeight - paddingTop - paddingBottom - paddingTopInner - paddingBottomInner - topModifier;

                    // const maxWidth = windowWidth;
                    // const maxHeight = windowHeight;

                    let lightboxSize;

                    let adjustedWidth = view.privateVars.videoSize.width;
                    let adjustedHeight = view.privateVars.videoSize.height;

                    if (width !== '' && height !== '' && parseInt(width) >= 400 && parseInt(height) >= 400) {
                        adjustedWidth = parseInt(width);
                        adjustedHeight = parseInt(height);
                    }

                    //adjustedWidth = adjustedWidth + paddingLeft + paddingRight;
                    //adjustedHeight = adjustedHeight + paddingTop + paddingBottom;

                    lightboxSize = view.methods.calculateSizeProportionForMaxValues(maxWidth, maxHeight,
                        adjustedWidth, adjustedHeight);

                    const newWidth = lightboxSize.width + paddingLeft + paddingRight + paddingLeftInner + paddingRightInner;
                    const newHeight = lightboxSize.height + paddingTop + paddingBottom + paddingTopInner + paddingBottomInner;

                    $(view.publicVars.cssId.moduleAboutVideoLightboxAreaId)
                        .css({width: newWidth + 'px', height: newHeight + 'px'});

                },

                calculateSizeProportionForMaxValues: (maxWidth, maxHeight, width, height) => {

                    if (width <= maxWidth && height <= maxHeight) {
                        return {width: width, height: height};
                    }

                    const widthHeightRatio = width / height;
                    const heightWidthRatio = height / width;

                    if (width > maxWidth) {

                        const widthDiff = width - maxWidth;
                        width = maxWidth;
                        height = height - (heightWidthRatio * widthDiff);
                    }

                    if (height > maxHeight) {
                        const heightDiff = height - maxHeight;
                        height = maxHeight;

                        width = width - (widthHeightRatio * heightDiff);
                    }

                    return {width: width, height: height};
                }
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    lightbox.init(options.lightboxSetup);
                    view.init(options);
                    slider.init(options.sliderSetup);
                    slider.setElementDecorateCallback(view.methods.decorateSliderElement);
                    slider.setCallback('beforeSlide', view.methods.beforeSlideCallback);
                }
            };


        })();


    });
